import React, { useCallback } from 'react';
import type { VcsApi } from '@env0/vcs-service/api';
import Button from 'components/common/button';
import { FormattedMessage } from 'react-intl';
import { useVcsOAuthPopup } from 'hooks/use-vcs-oauth-popup.hook';

type VcsAuthorizationButtonProps = {
  connectionType: VcsApi.ConnectionType;
  vcsType: VcsApi.VcsType;
  authenticationType?: VcsApi.OAuthAuthenticationType;
  accessScope?: string;
  onClosed: (result: OAuthResult) => void;
  onTokenProcessingChange?: (isProcessing: boolean) => void;
};

export type OAuthResult = {
  accessScope?: string;
  authorizationId?: string;
  tokenId?: string;
  error?: string;
  isAlreadySaved?: boolean;
};

const VcsConnectionModalFormOauthAuthorizationButton: React.FunctionComponent<VcsAuthorizationButtonProps> = ({
  connectionType,
  vcsType,
  authenticationType,
  accessScope,
  onClosed,
  onTokenProcessingChange
}) => {
  const handleSuccess = useCallback(
    (result: OAuthResult) => {
      onClosed(result);
    },
    [onClosed]
  );

  const handleError = useCallback(
    (error: string) => {
      onClosed({ error });
    },
    [onClosed]
  );

  const { openOAuthPopup } = useVcsOAuthPopup({
    connectionType,
    vcsType,
    authenticationType,
    accessScope,
    onSuccess: handleSuccess,
    onError: handleError,
    onTokenProcessingChange
  });

  return (
    <Button data-e2e={'vcs-connection-modal-oauth-authorization-button'} type="primary" onClick={openOAuthPopup}>
      <FormattedMessage id="organization.settings.agents.vcs-connections-modal.connection.oauth.button" />
    </Button>
  );
};

export default VcsConnectionModalFormOauthAuthorizationButton;
